module.exports = "/_next/static/images/coupe-d5b6b4f35385a799287649e167e14121.jpg";